export default __webpack_public_path__ + "static/media/baoguWoman.94da25e1.png";